import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { WebAPIService } from 'src/app/services/webapi/web-api.service';
import { WebAPIConstants } from 'src/app/services/globalConstants/global-constants.service';
import { DeviceInfoService } from 'src/app/services/deviceInfo/device-info.service';

import { IProductoWeb } from 'src/app/interfaces/IProductoWeb';
import { IExistenciaWeb } from 'src/app/interfaces/IExistenciaWeb';

@Injectable({
  providedIn: 'root'
})
export class ProductoService {

  //#region Propiedades

  public AllProductos: Array<IProductoWeb> = [];
  public AllSucursales: Array<IExistenciaWeb> = [];
  public CurrentProductoWeb: IProductoWeb = null;

  //#endregion

  //#region Constructor

  constructor(private _webAPISrv: WebAPIService,
              private _deviceInfoSrv: DeviceInfoService) { }

  //#endregion

  public getNewProductoWeb(): IProductoWeb {
    const newItem: IProductoWeb = {
      IdProductoWeb: 0,
      Nombre: '',
      CodigoProducto: '',
      ProductoTxt: '',
      AllTamanos: []
    };

    return newItem;
  }

  public getAllProductosWeb(categoriaWebTxt: string, busquedaTxt: string, favoritos: boolean) {

    if (categoriaWebTxt == null || categoriaWebTxt == '') { categoriaWebTxt = '-'; }
    if (busquedaTxt == null || busquedaTxt == '') { busquedaTxt = '-'; }

    let favTxt: number = 0;
    if (favoritos == true) { favTxt = 1; }

    const url: string = WebAPIConstants.URLProducto + 'getAllProductosWeb/' + categoriaWebTxt + '/' + busquedaTxt + '/' + favTxt;
    const deviceUUID: string = this._deviceInfoSrv.CurrentDeviceInfo.DeviceUUID;
    const token: string = this._deviceInfoSrv.CurrentDeviceInfo.Token;

    return this._webAPISrv.get(url, deviceUUID, token, true).pipe(map((allItems: Array<IProductoWeb>) => {
      this.AllProductos = allItems;

      this.AllProductos.forEach(item => {
        switch (item.IdCategoriaWeb) {
          case 'PAST':
            item.ImgUrl32x32 = 'rebanada01.pink.32x32.png';
            break;
          case 'PAY':
            item.ImgUrl32x32 = 'pay02.pink.32x32.png';
            break;
          case 'REB':
            item.ImgUrl32x32 = 'quequito02.pink.32x32.png';
            break;
          case 'REPOS':
            item.ImgUrl32x32 = 'reposteria02.pink.32x32.png';
            break;
          case 'TEMP':
            item.ImgUrl32x32 = 'temporada01.pink.32x32.png';
            break;
          case 'TIENDA':
            item.ImgUrl32x32 = 'desechable01.pink.32x32.png';
            break;
          default:
            break;
        }
      });
      console.log('-------------------------------------------');
      console.log('ProductoService >> getAllProductos >> '  + this.AllProductos.length);
      console.log('-------------------------------------------');

    }));
  }

  public getProductoWeb(idProductoWeb: number, location:string) {

    const url: string = WebAPIConstants.URLProducto + 'getProductoWeb/' + idProductoWeb + '/' + location;
    const deviceUUID: string = this._deviceInfoSrv.CurrentDeviceInfo.DeviceUUID;
    const token: string = this._deviceInfoSrv.CurrentDeviceInfo.Token;

    return this._webAPISrv.get(url, deviceUUID, token, true).pipe(map((item: IProductoWeb) => {
      this.CurrentProductoWeb = item;

      switch (this.CurrentProductoWeb.IdCategoriaWeb) {
        case 'PAST':
          this.CurrentProductoWeb.ImgUrl32x32 = 'rebanada01.pink.32x32.png';
          break;
        case 'PAY':
          this.CurrentProductoWeb.ImgUrl32x32 = 'pay02.pink.32x32.png';
          break;
        case 'REB':
          this.CurrentProductoWeb.ImgUrl32x32 = 'quequito02.pink.32x32.png';
          break;
        case 'REPOS':
          this.CurrentProductoWeb.ImgUrl32x32 = 'reposteria02.pink.32x32.png';
          break;
        case 'TEMP':
          this.CurrentProductoWeb.ImgUrl32x32 = 'temporada01.pink.32x32.png';
          break;
        case 'TIENDA':
          this.CurrentProductoWeb.ImgUrl32x32 = 'desechable01.pink.32x32.png';
          break;
        default:
          break;
      }

      console.log('-------------------------------------------');
      console.log('ProductoService >> getProducto >> '  +
        this.CurrentProductoWeb.IdProductoWeb + ' - ' +
        this.CurrentProductoWeb.Nombre);
      console.log('-------------------------------------------');

    }));
  }

  public getAllExistenciasWeb(idSucursal: string, idProductoWeb: number) {

    const url: string = WebAPIConstants.URLExistencias + 'getAllExistenciasWeb/' + idSucursal + '/' + idProductoWeb;
    const deviceUUID: string = this._deviceInfoSrv.CurrentDeviceInfo.DeviceUUID;
    const token: string = this._deviceInfoSrv.CurrentDeviceInfo.Token;

    return this._webAPISrv.get(url, deviceUUID, token, true).pipe(map((allItems: Array<IExistenciaWeb>) => {
      this.AllSucursales = allItems;

      console.log('-------------------------------------------');
      console.log('ProductoService >> getAllExistenciasWeb >> '  + this.AllSucursales.length);
      console.log('-------------------------------------------');

    }));
  }
}
